import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router             } from '@angular/router';

import { SwiperOptions } from 'swiper/types';

import { CandidatesService, TrackerService } from '@shared/services';
import { CandidateModel } from '@shared/models';

@Component({
  selector:      'candidates-carousel',
  templateUrl: './candidates-carousel.component.html',
  styleUrl:    './candidates-carousel.component.sass',
  host: {'[class.display-none]': '!showCandidateCarousel'},
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CandidatesCarouselComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  candidates:    CandidateModel[];
  swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween:  12,
    pagination:  {
      clickable: true
    }
  };

  constructor(
    public  router:            Router,
    public  candidatesService: CandidatesService,
    private trackerService:    TrackerService,
  ) { }

  get showCandidateCarousel(): boolean {
    const allowPaths = [
      '/time-tracking/list',
      '/time-tracking/vr-list',
      '/time-tracking/assignments-list'
    ];
    return this.candidates?.length && allowPaths.some(it => this.router?.url?.includes(it));
  };

  ngOnInit(): void {
    this.candidatesService.candidates.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(candidates => {
      this.candidates = candidates?.map(c => {
        const { url } = this.candidatesService.getTemptonConnectCandidatePage(c);
        if (url) c.url = url;
        return c;
      });
    });
  }

  trackCandidateClick(candidate: CandidateModel): void {
    const { companyNumber, userId } = this.candidatesService.getTemptonConnectCandidatePage(candidate);
    if (companyNumber && userId) {
      this.trackerService.trackActivity({
        resource_type: 'worker_suggestions',
        event_name:    'click_candidate',
        additional_data: {
          candidate_id:    candidate.worker_id,
          candidate_name: `${candidate.first_name} ${candidate.last_name}`,
          company_number:  companyNumber,
          user_id:         userId
        }
      }).subscribe({
        error: err => console.error('Error tracking candidate click:', err)
      });
    }
  }

}
